var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAccountMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_2771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.767 15.4351H6.76703C5.66246 15.4351 4.9416 16.3312 5.55787 17.2479C6.78448 19.0724 9.4073 21.4351 13.2115 21.4351C16.9697 21.4351 19.148 19.1291 20.1309 17.3142C20.657 16.3429 19.8716 15.4351 18.767 15.4351Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.767 6.78993C15.767 8.64275 14.4239 11.4351 12.767 11.4351C11.1102 11.4351 9.76703 8.64275 9.76703 6.78993C9.76703 4.9371 11.1102 3.43509 12.767 3.43509C14.4239 3.43509 15.767 4.9371 15.767 6.78993Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_2771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.767029 0.435089)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountMobile);
export default __webpack_public_path__ + "static/media/ic_account_mobile.29f083a900faede250300cbb3b7af86c.svg";
export { ForwardRef as ReactComponent };